import { isNil } from 'lodash'
import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import UserAction from '../../administration/components/user/actions/UserAction'
import { CAMPAIGN_BOOKMARK_TYPE } from '../../campaign/constants/CampaignConstants'
import { favOrange } from '../constants/ColorTheme'

const useCampaignBookmarks = stationType => {
    const dispatch = useDispatch()
    const userBookmarks = useSelector(store => store.UserReducer.userBookmarks)
    const login = useSelector(store => store.AccountReducer.accountUser.login)

    const bookmarkType = CAMPAIGN_BOOKMARK_TYPE[stationType]

    const bookmarkIds = useMemo(() => userBookmarks
        .filter(bookmark => bookmark.stationType === bookmarkType)
        .map(bookmark => parseInt(bookmark.identifiant)), [userBookmarks, bookmarkType])

    const toggleBookmark = id => {
        const bookmark = { identifiant: `${id}`, login, stationType: bookmarkType }
        return bookmarkIds.includes(id) ? dispatch(UserAction.deleteBookmark(bookmark)) : dispatch(UserAction.createBookmark(bookmark))
    }

    const getBookmarkAction = id => {
        const isBookmarked = bookmarkIds.includes(id)
        return {
            icon: isBookmarked ? 'star' : 'star_border',
            color: favOrange,
            tooltip: isBookmarked ? i18n.removeFavorite : i18n.addFavorite,
            onClick: () => toggleBookmark(id),
            displayed: !isNil(bookmarkType),
        }
    }

    return {
        isBookmarkable: !isNil(bookmarkType),
        bookmarkIds,
        toggleBookmark,
        getBookmarkAction,
    }
}

export default useCampaignBookmarks
